/* @flow */

import React, { useEffect } from "react";

import { PriceLock as PriceLockModal } from "@crossroads/shop-views";
import { subscribeToNewsletter } from "queries";
import { useClient } from "entrypoint/shared";
import { useUi, MODE } from "helpers/ui";
import useShowPrices from "helpers/use-show-prices";
import { parseParams } from "helpers/location-search-string";
import { useHistory, useLocation } from "react-router-dom";
import { useSendMessage } from "crustate/react";
import { addMessage } from "@crossroads/shop-state/messages";

type ImageItem = {
  src: string,
  title: string,
};

const PriceLock = (): React$Node => {
  const { setViewMode, viewMode } = useUi();
  const location = useLocation();
  const { replace } = useHistory();
  const { showPrices, setShowPrices, showPricesRead } = useShowPrices();
  const sendMessage = useSendMessage();
  const images: Array<ImageItem> = [];

  useEffect(() => {
    const { subscribed } = parseParams(location.search);

    if (subscribed && subscribed === "true") {
      sendMessage(addMessage("NEWSLETTER.SUCCESS", "success"));
      const search = location.search.replace(/(&|\?)(subscribed=true)/g, "");
      window.setTimeout(() => {
        replace({ location: location.pathname, search });
      }, 200);
    }
  }, [location]);

  const handleClosedModal = (value: string) => {
    setViewMode(MODE.NORMAL);
    setShowPrices(value);
  };

  if (!showPricesRead || showPrices) {
    return null;
  }

  return (
    <PriceLockModal
      subscribeToNewsletter={subscribeToNewsletter}
      useClient={useClient}
      isOpen={viewMode === MODE.PRICE_LOCK}
      closeModal={value => handleClosedModal(value)}
      images={images}
    />
  );
};

export default PriceLock;
